import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Mainlayout from '../layouts/mainlayout';
import Dashboard from '../components/dashboard';
import EMICalculator from '../screens/emi-calculator';
import RecurringDepositCalculator from '../screens/recurringdeposit';
import FixedDepositCalculator from '../screens/fixed-deposit-calculator';
import SystematicInvestmentPlanCalculator from '../screens/systematic-investment-plan';
import SystematicWithdrawalPlan from '../screens/systematic-withdrawal-plan';
import LumpSumCalculator from '../screens/LumpSum-Calculator';
import StepUpSIPCalculator from '../screens/step-up-sip-calculator';
import GoalSIPCalculator from '../screens/goal-sip-calculator';
import LoanComparison from '../screens/loan-comparison-calculator';
import SavedCalculations from './saved-calculations';
import InterestCalculator from '../screens/interest';
import PrivacyPolicy from '../utils/privacyPolicy';
const Router = () => {
  return (
    <Routes>
      <Route path='/' element={<Mainlayout />}>
        <Route index element={<Dashboard />} />
        <Route path='/saved' element={<SavedCalculations />} />
        <Route path='/interestCalculator.html' element={<InterestCalculator />} />
        <Route path='/emi-calculator.html' element={<EMICalculator />} />
        <Route path='/recurring-deposit.html' element={<RecurringDepositCalculator />} />
        <Route path='/fixed-deposit-calculator.html' element={<FixedDepositCalculator />} />
        <Route path='/sip-calculator.html' element={<SystematicInvestmentPlanCalculator />} />
        <Route path='/swp-calculator.html' element={<SystematicWithdrawalPlan />} />
        <Route path='/lumpsum-calculator.html' element={<LumpSumCalculator />} />
        <Route path='/stepup-sip-calculator.html' element={<StepUpSIPCalculator />} />
        <Route path='/goal-sip-calculator.html' element={<GoalSIPCalculator />} />
        <Route path='/loan-comparision-calculator.html' element={<LoanComparison />} />
        <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />


      </Route>
    </Routes>
  );
}

export default Router;
